module.exports = __webpack_public_path__ + "img/数据采集.aca72233.svg";